import React from 'react';
import Button from 'components/UIComponents/Button';
import classnames from 'classnames';

import './style.scss';

const Filter = ({ className, children }) => {
  return (
    <div className={classnames('filter__wrap', className)} role="radiogroup">
      {children}
    </div>
  );
};

export const FilterButton = ({
  value,
  children,
  selectedValue,
  onClick,
  ...props
}) => (
  <Button
    color="primary"
    className="filter__btn"
    outlined={value !== selectedValue}
    onClick={onClick}
    role="radio"
    aria-checked={value === selectedValue}
    {...props}
  >
    {children}
  </Button>
);

export default Filter;
